(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-hover-video video').forEach(video => {
    video.muted = true;
    video.playsInline = true;
    video.loop = true;
    video.pause();

    const wrapper = video.closest('.card-wrapper');

    if (wrapper) {
      wrapper.addEventListener('mouseenter', () => {
        video.currentTime = 0;
        video.play();
      });

      wrapper.addEventListener('mouseleave', () => {
        video.pause();
      });
    }
  });
});
  } catch(e) { console.error(e); }
})();

})();
